import { Grid, Typography } from '@mui/material';
import { CopyButton } from '@tassat/button';
import * as React from 'react';

import muiStyles from './styles';
import { ButtonType, WalletAddressProps } from './types';

export default function WalletAddress(props: WalletAddressProps) {
    const {
        id,
        className,
        isAdmin,
        walletAddress,
        buttonType
    } = props;

    const classes = muiStyles(props);

    const renderButton = () => {
        let valueToCopy = '-';
        if (walletAddress && walletAddress !== '-') {
            valueToCopy = `S${walletAddress.substring(2)}`;
        }

        return (
            <CopyButton
                buttonType={buttonType}
                copyPrompt='Copy Address'
                textToCopy={valueToCopy}
            />
        );
    };

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction={buttonType === ButtonType.SMALL ? 'row' : 'column'}
            spacing={0}
            wrap='nowrap'
        >
            <Typography
                className={`${className} ${!isAdmin && classes.nonSelectableText}`}
                id={id}
                variant='body2'
            >
                {walletAddress}
            </Typography>
            {!isAdmin && walletAddress !== '-' && renderButton()}
        </Grid>
    );
}